var React = require('react');

function TrophyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.8002 27.2H19.2002M8.0002 4.79999H24.0002V12.8C24.0002 17.2183 20.4185 20.8 16.0002 20.8C11.5819 20.8 8.0002 17.2183 8.0002 12.8V4.79999ZM8.06131 15.3607C5.20326 14.1404 3.2002 11.3041 3.2002 7.99999H8.0002L8.06131 15.3607ZM24.0002 7.99999H28.8002C28.8002 11.3267 26.7697 14.1791 23.8804 15.3855L24.0002 7.99999ZM16.0002 20.8V27.2V20.8Z","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

TrophyInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = TrophyInline;

TrophyInline.default = TrophyInline;
